import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { BusResponse } from '../../participante/models/processo-manual.model';
import { ArquivoDocumentoManualDTO } from '../../documento/models/proposta-manual-documento.model';
import { DadosProposta } from '../models/dados-proposta.model';

export const PROPOSTA_FINANCIAMENTO_REPOSITORY = new InjectionToken<PropostaFinanciamentoRepository>('PropostaFinanciamentoRepository');

export interface PropostaFinanciamentoRepository {
  buscarDadosProposta(matricula: string): Observable<DadosProposta>;
  salvarRascunhoDadosPropostaManual(matricula: string, dados: DadosProposta): Observable<DadosProposta>;
  finalizarDadosPropostaManual(matricula: string, dados: DadosProposta): Observable<BusResponse<ArquivoDocumentoManualDTO>>;
}
